import { Directive, ElementRef, Output } from '@angular/core';

@Directive({
  selector: '[deep-blur]',
  host: { '(blur)': 'onBlur($event)'}
})
export class DeepBlurDirective {

  constructor(private elRef: ElementRef) {
  }

  onBlur($event) {
    this.elRef.nativeElement.dispatchEvent(new CustomEvent('deepBlur', { bubbles: true }));
  }
}
